import React, { useState, useEffect, useRef } from 'react';
import { faPaperclip, faXmark } from '@fortawesome/free-solid-svg-icons';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';
import { applyOffsetToDateTime, CallApi } from '../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import CommonGrid from '../../../Components/common/CommonGrid';
import View from "../../../assets/images/view.png";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';

const MessageLog = () => {
    const [selectedRowData, setSelectedRowData] = useState();
    const [gridSelect,setGridSelect] = useState([])
    const isMounted = useRef(true);

        const datafields = [
        { name: "event_time", type:"string" },
        { name: "interchange_ref", type:"string" },
        { name: "inv_movement_direction_code", type:"string" },
        { name: "inv_type_code", type:"string" },
        { name: "inventory_code", type:"string" },
        { name: "measurement_unit", type:"string" },
        { name: "message_ref", type:"string" },
        { name: "msg_creation", type:"string" },
        { name: "msg_time", type:"string" },
        { name: "party_indentifier", type:"string" },
        { name: "pieces", type:"string" },
        { name: "updated_at", type:"string" },
        { name: "weight", type:"string" },
        { name: "movement", type:"string" },
        { name: "created_by_user", type: "object" },
        { name: 'file_name', type: 'string' },
        { name: 'message', type: 'string' },
        { name: 'awb', type: 'string' },
        // { name: 'movement_id', type: 'string' },
        // { name: 'org_id', type: 'string' },
        { name: "trucking_organisation", type: "object" },   
        { name: "movement_type", type: "object" },   
        { name: "in_out_doc_type", type: "object" },   
        { name: "in_out_doc_no", type: "object" },   

    ]

        const columns = [
            {
            text: 'Action',
            cellsrenderer: function () {
              return '<div class="grid_actions"><img src="' + View + '" class="row_edit" /></div>';
            },
            filterable:false,
            width: '5%'
          },
          {
                text: "Record Id", datafield: "movement", width: "10%",
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowData) => {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">' + rowData?.movement?.shipment_record?.cargohub_id || '' + '</div>';
                },
            },
            { text: 'MAWB', filtertype: 'awb', datafield: 'awb', width: '10%', cellclassname: 'frcl', },

            {
                text: "Full Name", datafield: "created_by_user", width: "10%",
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowData) => {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">' + rowData.created_by_user.first_Name + " " + rowData.created_by_user.last_Name + '</div>';
                },
            },
        { text: 'File Name', filtertype: 'file_name', datafield: 'file_name', width: '20%', cellclassname: 'frcl', },
        // { text: 'Message', filtertype: 'message', datafield: 'message', width: '33%', cellclassname: 'frcl', },
        // { text: 'Movement Id', filtertype: 'movement_id', datafield: 'movement_id', width: '10%', cellclassname: 'frcl', },
        // { text: 'Org Id', filtertype: 'org_id', datafield: 'org_id', width: '10%', cellclassname: 'frcl', },
            {
                text: "Trucking Organisation", datafield: "trucking_organisation", width: "12%",
                cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowData) => {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">' + rowData.trucking_organisation.org_Name + '</div>';
                },
            },
    ];

        const gridData = {
        Tab: 0,
        TabName: [], // {Active: [], Archives: []}
        Token: `RFS`,
        page: 'allstn',
        EndPoint: 'shipment/get-cargonaut-messages',
        Datafields: datafields,
        Columns: columns,
        nested: false,
        rowClick: true,
        Options: {
            height: 700,
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            selectionmode: 'checkbox',
        },
    }

    const loadDetails = (data) => {
        if (isMounted.current) {
            isMounted.current = false;
            return;
        }
        if (!data) return;
        setSelectedRowData(data)
            // console.log(data);
            
            // CallApi({
            //     endPoint: 'uld-settings/stations-details',
            //     payload: {station_id: data.station_id},
            //     onSuccess: (data) => {
            //         // console.log('sendData', data);
            //         const resCode = data.data.response_code;
            //         if (resCode === 200) {
            //             const innerData = data.data.response_data;
                        
            //             setSelectedRowData(innerData)
            //         } else {
            //             toast.error(data.response_msg);
            //         }
            //     },
            //     onError: (msg) => toast.error(msg)
            // });
            // setSelectedRowData(data)
    }

       const handleCloseClick = () => {
        setSelectedRowData(null);
        // setTimeout(() => {
        //     window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        // }, 30);
    };

    const handleOpenModal = async(apiData) => {
        console.log("apiDataaa",apiData)
        const url = "/ForwarderShipments/AddShipmentRecords"
         if (apiData.section == 'cellclick') {
            setSelectedRowData(apiData.data)
        } else if (apiData.section == 'row_edit') {
            localStorage.setItem('SHEdit', JSON.stringify(apiData?.data.movement.import_shipment_record_id));
            window.location.href = url;
            localStorage.setItem("AddShipmentType", "import");
            localStorage.setItem("ccbackUrl", "/ForwarderShipments/Log");
        }
    }

    
    return (
         <div className="">
            <Header page_type='fsm' logo_url='/ForwarderShipments/Import' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <TopMenu module='FSHPMNGR' />
                        <div className="">
                            <div className="allcontent-fl">
                                <div className="lcontent">
                                    <div className="maindiv">
                                        <div className='trashdonload position-relative'>
                                            {/* <div ref={gridRefs.active} className='bookinggrid' ></div> */}
                                            <CommonGrid onAction={handleOpenModal} GD={gridData} onSwitch={''} detailsData={loadDetails} setGridSelect={setGridSelect}/>
                                        </div>
                                        {selectedRowData && (
                                            <div className="SecondDiv mt-3 uld_msg">
                                                {/* {console.log('55', selectedRowData)} */}
                                                <button className="close" onClick={handleCloseClick}>
                                                    {" "}
                                                    <FontAwesomeIcon icon={faXmark} />{" "}
                                                </button>
                                                <div className='girddtals_header'>
                                                    <h3>{selectedRowData?.movement?.shipment_record?.cargohub_id}</h3>
                                                    </div>
                                                <div className='mt-2'>
                                                    <h3>Message</h3>
                                                    {/* <p dangerouslySetInnerHTML={{ __html: selectedRowData }}></p> */}
                                                    <p className='side_log_msg'>{selectedRowData.message}</p>
                                                </div>
                                                
                                                <div>
                                                    <h3>Message Info</h3>
                                                    <ul className='truck_info'>
                                                        <li><span>Movement Type :</span> <span>{selectedRowData?.movement_type}</span></li>
                                                        <li><span>Event Time :</span> <span>{selectedRowData?.event_time}</span></li>
                                                        <li><span>Interchange Ref :</span> <span>{selectedRowData?.interchange_ref}</span></li>
                                                        <li><span>Inv Movement Direction Code :</span> <span>{selectedRowData?.inv_movement_direction_code}</span></li>
                                                        <li><span>Inv Type Code :</span> <span>{selectedRowData?.inv_type_code}</span></li>
                                                        <li><span>Inventory Code :</span> <span>{selectedRowData?.inventory_code}</span></li>
                                                        <li><span>Measurement Unit :</span> <span>{selectedRowData?.measurement_unit}</span></li>
                                                        <li><span>Message Ref :</span> <span>{selectedRowData?.message_ref}</span></li>
                                                        <li><span>Message Creation :</span> <span>{selectedRowData?.msg_creation}</span></li>
                                                        <li><span>Message Time :</span> <span>{selectedRowData?.msg_time}</span></li>
                                                        <li><span>Party Identifier :</span> <span>{selectedRowData?.party_indentifier}</span></li>
                                                        <li><span>Pieces :</span> <span>{selectedRowData?.pieces}</span></li>
                                                        <li><span>Org Name :</span> <span>{selectedRowData?.trucking_organisation?.org_Name}</span></li>
                                                        <li><span>Updated At :</span> <span>{applyOffsetToDateTime(selectedRowData?.updated_at)}</span></li>
                                                        <li><span>Weight :</span> <span>{selectedRowData?.weight}</span></li>
                                                        <li><span>MAWB :</span> <span>{selectedRowData?.awb}</span></li>
                                                        <li><span>Doc Type :</span> <span>{selectedRowData?.in_out_doc_type}</span></li>
                                                        <li><span>Doc Number :</span> <span>{selectedRowData?.in_out_doc_no}</span></li>
                                                    </ul>
                                                    
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    )
}

export default MessageLog